import partner from "../../assets/img/partner.png";
import Title from "../common/Title";
import PartnerBooking from "./PartnerBooking";

const TravelPartner = () => {
  return (
    <div>
      <div className="container sm:px-5 px-4 mx-auto 2xl:max-w-[1240px] relative sm:pt-24 pt-20">
        <div className="grid xl:grid-cols-2 items-center gap-10">
          <div className="max-w-[500px] xl:max-w-full">
            <Title
              text="Why TripNest is Your Travel Partner"
              myClass="sm:mb-10 mb-7"
            />
            <img
              className="w-full rounded-[20px]"
              src={partner}
              alt="partner"
            />
          </div>
          <div>
            <PartnerBooking />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelPartner;
